import type { InputTableColumn } from '@/components/custom/erp/input-table-v2';
import CellFieldV2 from '@/components/custom/erp/cell-field-v2';

export const getDetailTableColumnsV2 = (): InputTableColumn[] => [
  {
    field: 'ma_vt',
    headerName: 'Mã sản phẩm',
    width: 120,
    renderCell: params => params.row.ma_vt_data?.ma_vt || ''
  },
  {
    field: 'ten_vt',
    headerName: 'Tên sản phẩm',
    width: 200,
    renderCell: params => params.row.ma_vt_data?.ten_vt || ''
  },
  {
    field: 'dvt',
    headerName: 'Đơn vị tính',
    width: 100,
    renderCell: params => params.row.dvt_data?.dvt || params.row.dvt || ''
  },
  {
    field: 'ma_kho',
    headerName: 'Mã kho',
    width: 120,
    renderCell: params => params.row.ma_kho_data?.ma_kho || ''
  },
  {
    field: 'ma_vi_tri',
    headerName: 'Mã vị trí',
    width: 120,
    renderCell: params => params.row.ma_vi_tri_data?.ma_vi_tri || ''
  },
  {
    field: 'so_luong',
    headerName: 'Số lượng',
    width: 100,
    align: 'right',
    headerAlign: 'right',
    renderCell: params => <CellFieldV2 name='so_luong' type='number' disabled value={params.row.so_luong} />
  },
  {
    field: 'tien0',
    headerName: 'Tiền hàng',
    width: 120,
    align: 'right',
    headerAlign: 'right',
    renderCell: params => <CellFieldV2 name='tien_nt' type='number' disabled value={params.row.tien_nt} />
  },
  {
    field: 'tien3',
    headerName: 'Tiền tính thuế nk',
    width: 120,
    align: 'right',
    headerAlign: 'right',
    renderCell: params => <CellFieldV2 name='tien3' type='number' disabled value={params.row.tien3} />
  },
  {
    field: 'cp_nt',
    headerName: 'Chi phí VND',
    width: 120,
    align: 'right',
    headerAlign: 'right',
    renderCell: params => <CellFieldV2 name='cp_nt' type='number' disabled value={params.row.cp_nt} />
  },
  {
    field: 'tk_vt',
    headerName: 'TK nợ',
    width: 120,
    renderCell: params => <CellFieldV2 name='tk_vt' disabled value={params.row.tk_vt_data?.code} />
  },
  {
    field: 'thue_nt',
    headerName: 'Thuế GTGT VND',
    width: 120,
    align: 'right',
    headerAlign: 'right',
    renderCell: params => <CellFieldV2 name='thue_nt' type='number' disabled value={params.row.thue_nt} />
  },
  {
    field: 'ma_bp',
    headerName: 'Bộ phận',
    width: 120,
    renderCell: params => <CellFieldV2 name='ma_bp' disabled value={params.row.ma_bp_data?.ma_bp} />
  },
  {
    field: 'ma_vv',
    headerName: 'Vụ việc',
    width: 120,
    renderCell: params => <CellFieldV2 name='ma_vv' disabled value={params.row.ma_vv_data?.ma_vu_viec} />
  },
  {
    field: 'ma_hd',
    headerName: 'Hợp đồng',
    width: 120,
    renderCell: params => <CellFieldV2 name='ma_hd' disabled value={params.row.ma_hd_data?.ma_hd} />
  },
  {
    field: 'ma_dtt',
    headerName: 'Đợt thanh toán',
    width: 120,
    renderCell: params => <CellFieldV2 name='ma_dtt' disabled value={params.row.ma_dtt_data?.ma_dtt} />
  },
  {
    field: 'ma_ku',
    headerName: 'Khế ước',
    width: 120,
    renderCell: params => <CellFieldV2 name='ma_ku' disabled value={params.row.ma_ku_data?.ma_ku} />
  },
  {
    field: 'ma_phi',
    headerName: 'Phí',
    width: 120,
    renderCell: params => <CellFieldV2 name='ma_phi' disabled value={params.row.ma_phi_data?.ma_phi} />
  },
  {
    field: 'ma_sp',
    headerName: 'Sản phẩm',
    width: 120,
    renderCell: params => <CellFieldV2 name='ma_sp' disabled value={params.row.ma_sp_data?.ma_vt} />
  },
  {
    field: 'ma_lsx',
    headerName: 'Lệnh sản xuất',
    width: 120,
    renderCell: params => <CellFieldV2 name='ma_lsx' disabled value={params.row.ma_lsx_data?.ma_lsx} />
  },
  {
    field: 'ma_cp0',
    headerName: 'C/p không h/lệ',
    width: 150,
    renderCell: params => <CellFieldV2 name='ma_cp0' disabled value={params.row.ma_cp0_data?.ma_cp} />
  },
  {
    field: 'so_ct_hd4',
    headerName: 'Số hóa đơn mua trong nước',
    width: 170,
    renderCell: params => <CellFieldV2 name='so_ct_hd4' disabled value={params.row.so_ct_hd4} />
  },
  {
    field: 'so_ct_hd5',
    headerName: 'Số hóa đơn mua nhập khẩu',
    width: 170,
    renderCell: params => <CellFieldV2 name='so_ct_hd5' disabled value={params.row.so_ct_hd5} />
  },
  {
    field: 'so_ct_hd7',
    headerName: 'Số hóa đơn mua xuất thẳng',
    width: 170,
    renderCell: params => <CellFieldV2 name='so_ct_hd7' disabled value={params.row.so_ct_hd7} />
  },
  {
    field: 'line_hd',
    headerName: 'Dòng HĐ',
    width: 100,
    renderCell: params => <CellFieldV2 name='line_hd' disabled value={params.row.line_hd} />
  }
];
